import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Loader2 } from 'lucide-react';

export default function ProtectedRoute({ children }) {
  const { admin } = useAuth();

  if (admin === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#E8F5FA]">
        <Loader2 className="w-10 h-10 text-[#7DBDD9] animate-spin" />
      </div>
    );
  }

  if (admin === false) {
    return <Navigate to="/admin/login" replace />;
  }

  return children;
}
